// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cardContainerStyles } from "@insite/content-library/Components/CardContainer";
import { cardContainerMultiColumnStyles } from "@insite/content-library/Components/CardContainerMultiColumn";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

// -------------------------------------------------PLP List Card --------------------------------------
// style of PLP List View top level iterating items goes here
cardContainerStyles.cardDivider = {
    css: css`
        width: 100%;
        padding: 20px 0;
        border-top: 1px solid ${getColor("common.ui2")};
        &:last-child {
            border-bottom: 2px solid ${getColor("common.ui3")};
            margin-bottom: 28px;
        }
    `,
};

cardContainerStyles.gridItem = {
    width: 12,
};
// end of PLP List View top level iterating items style

// -------------------------------------------------PLP Grid Card -------------------------------------
// style of PLP Grid View top level iterating items goes here
cardContainerMultiColumnStyles.gridItem = {
    css: css`
        padding-left: 15px;
        padding-right: 15px;
        &&&& {
            margin-bottom: 50px;
        }

        width: calc(100% / 4);
        flex-basis: calc(100% / 4);
        max-width: calc(100% / 4);

        @media (max-width: 1430px) and (min-width: 1000px) {
            width: calc(100% / 3);
            flex-basis: calc(100% / 3);
            max-width: calc(100% / 3);
        }

        @media only screen and (max-width: 999px) {
            width: calc(100% / 2);
            flex-basis: calc(100% / 2);
            max-width: calc(100% / 2);
        }

        @media only screen and (max-width: 650px) {
            width: 100%;
            flex-basis: 100%;
            max-width: 100%;
        }
    `,
};
cardContainerMultiColumnStyles.cardDivider = {
    css: css`
        height: 100%;
        width: 100%;
    `,
};
// end of PLP Grid View top level iterating items style
